/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Tab_DraftInputs */

const en_admin_posts_tab_draft = /** @type {(inputs: Admin_Posts_Tab_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

const zh_admin_posts_tab_draft = /** @type {(inputs: Admin_Posts_Tab_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`草稿`)
};

/**
* | output |
* | --- |
* | "Draft" |
*
* @param {Admin_Posts_Tab_DraftInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_tab_draft = /** @type {((inputs?: Admin_Posts_Tab_DraftInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Tab_DraftInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_tab_draft(inputs)
	return zh_admin_posts_tab_draft(inputs)
});
export { admin_posts_tab_draft as "admin.posts.tab_draft" }